import React, { useState } from 'react'
import { Choice, ChoiceCard, OptionsBullets, QuizCheck } from '../../../theme'

function TextChoices(props) {
  const [selected, setSelected] = useState('')
  const {
    value,
    onSelect,
    choices,
    correctIndex,
    neutralQuestion,
    reference,
    quesType,
    parentScreen,
    quesId,
    finalAttempt,
  } = props
  const selectOptionhandler = (index) => {
    onSelect(index)
  }

  return (
    <>
      {console.log('selectedAnswerindex', value)}
      {choices.map((choice, index) => (
        <ChoiceCard
          bgcolor={
            window.location.pathname == '/worksheetquiz' ||
            window.location.pathname == '/kid-assessment' ||
            window.location.pathname == '/parent-screener'
              ? 'white'
              : '#B4CAE5'
          }
          key={index.toString()}
          // onClick={() => value == null && !parentScreen && onSelect(index)}
          onClick={() =>
            value == null && !parentScreen
              ? onSelect(index, quesId)
              : parentScreen && value == null
              ? onSelect(index, quesId)
              : null
          }
          selectedAns={
            quesType === 'worksheet' && !finalAttempt && value !== null
              ? value === index && correctIndex === index
                ? '#39c979'
                : value === index && correctIndex !== index
                ? '#EBAEAF'
                : ''
              : value !== null && parentScreen
              ? value == index
                ? '#39c979'
                : ''
              : ''
          }
          correct={
            !quesType || finalAttempt
              ? parentScreen
                ? selected === index
                : value !== null && correctIndex === index
                ? 1
                : 0
              : 0
          }
          wrong={
            !quesType || finalAttempt
              ? parentScreen
                ? null
                : value !== null && correctIndex !== index && value === index
                ? true
                : false
              : 0
          }
          neutralQuestion={neutralQuestion}
        >
          <div className="d-flex justify-content-start align-items-center">
            <div>
              <QuizCheck
                bgcolor={
                  window.location.pathname == '/worksheetquiz' ||
                  window.location.pathname == '/kid-assessment'
                    ? 'white'
                    : '#B4CAE5'
                }
                border={
                  parentScreen
                    ? 'none'
                    : window.location.pathname == '/worksheetquiz' ||
                      parentScreen ||
                      window.location.pathname == '/kid-assessment'
                    ? '#FADC4F'
                    : '#447BBE'
                }
              >
                <OptionsBullets
                  className="d-flex align-items-center justify-content-center"
                  bgcolor={
                    window.location.pathname == '/worksheetquiz' ||
                    window.location.pathname == '/kid-assessment'
                      ? 'white'
                      : '#B4CAE5'
                  }
                  selectedAns={
                    quesType === 'worksheet' && value !== null
                      ? value === index && correctIndex === index
                        ? 'green'
                        : value === index && correctIndex !== index
                        ? 'red'
                        : ''
                      : ''
                  }
                  correct={
                    !quesType
                      ? parentScreen
                        ? selected === index
                        : value !== null && correctIndex === index
                        ? 1
                        : 0
                      : 0
                  }
                  wrong={
                    !quesType
                      ? parentScreen
                        ? null
                        : value !== null &&
                          correctIndex !== index &&
                          value === index
                        ? true
                        : false
                      : 0
                  }
                  style={{ borderRadius: '100%' }}
                >
                  <strong style={{ marginTop: '3px' }}>
                    {window.location.pathname == '/worksheetquiz' ||
                    window.location.pathname == '/kid-assessment' ||
                    window.location.pathname == '/parent-screener'
                      ? ''
                      : index + 1}
                  </strong>
                </OptionsBullets>
              </QuizCheck>
            </div>
            <div>
              <Choice>{choice}</Choice>
            </div>
          </div>
        </ChoiceCard>
      ))}
    </>
  )
}

export default TextChoices
